<template>

      <div class="accessIndex">
        <div class="accessIndex__general_info">
          <div class="accessIndex__reload">
            <v-hover>
              <div  @click="getMyOwnData()" slot-scope="{ hover }" class="accessIndex__reload--container" :class="hover?'accessIndex__interaction--hover':''"  >
                <img src="../../../../assets/img/reload_blue.svg">
              </div>
            </v-hover>
            <p class="accessIndex__text--title" >Usuarios de {{myName}}</p>
          </div>
          <div  class="user__container--search">
            <v-text-field
              v-model="options_table.search"
              append-icon="search"
              label="Buscar .."
              single-line
              hide-details
            ></v-text-field>
        </div>
      </div>
        <div >
          <v-spacer></v-spacer>


        </div>
        <v-data-table
          v-if="isFinallyLoaded"
          id="myMainPannel"
          v-model="users"
          :headers="options_table.headers_table"
          :items="filteredUsers"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">
            <tr >

              <th
                v-for="header in options_table.headers_table"
                :key="header.text"
              >
                <div v-if="options_table.filters.hasOwnProperty(header.value)">
                  <v-select v-if="columnValueList(header.value)[0]!=null" flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="options_table.filters[header.value]" :placeholder="header.text">
                  </v-select>
                </div>
              </th>
            </tr>
            <tr>

              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr >

              <td class="text-xs-center">{{ props.item.name }}</td>
              <td class="text-xs-center email">{{ props.item.email }}</td>
              <td class="text-xs-center">{{ props.item.mobile }}</td>
              <td class="text-xs-center">{{ props.item.gender }}</td>
              <td class="text-xs-center">{{ props.item.age }}</td>


            </tr>
          </template>
        </v-data-table>
        <!-- <p v-else style="margin-top:50px" class="accessIndex__text--title" ></p> -->
        <v-layout
          v-else
          row
          wrap
          style="background-color: #fff; padding: 20px;margin-top:20px">  
          <v-flex xs12>
            
            <p style="text-align:center;font-size:20px;margin-top:40px">
              <b> <i>Cargando info...</i>  </b> 
            </p>
            <p style="text-align:center;font-size:15px">
              <i>Por favor espere</i>  
            </p>
          </v-flex>

        </v-layout>


        <v-divider></v-divider>




    </div>


</template>

<script>
export default {
  data(){
    return{
      selected: 'Todos los usuarios',
      notification_selector: ['Todos los usuarios', 'Varios usuarios'],
      notification: {
        attributes: {
          title: '',
          message: '',
          users: [],
          send_date_time: '',
          gmt: ''
        }
      },
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Usuario',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Email',
            align: 'center',
            value: 'email'
          },

          {
            text: 'Celular',
            align: 'center',
            value: 'mobile'
          },
          {
            text: 'Género',
            align: 'center',
            value: 'gender'
          },
          {
            text: 'Edad',
            align: 'center',
            value: 'age'
          },
        ],
        filters: {
          gender: [],
          age: [],
        },
      },

      users: [],
      users_for_select:[],
      right_now: true,
      rules: {
          required: value => !!value || 'Required.',
          title: value => value.length <= 200 || 'Maximo 45 caracteres',
          message: value => value.length <= 250 || 'Maximo 90 caracteres',
      },
      valid: false,
      isFinallyLoaded:false,
    }
  },
  beforeMount() {
    this.getMyOwnData();
  },
  created(){
    // this.reloadComp();
  },
  computed: {
    filteredUsers() {
      return this.users_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    },
    myName(){
      return localStorage.getItem("location_name")
    }
  },
  methods: {
    // reloadComp(){
    //   var self=this;
    //   setTimeout(function(){
    //     self.isFinallyLoaded = true;
    //   },1500)
    // },
    toggleAll () {
      var vm = this;
      var emails = document.querySelectorAll("table.v-datatable td.email");
      var check = document.querySelector(".v-table thead [aria-checked]").getAttribute("aria-checked");
      if (check=="false") {
        emails.forEach(function(element) {
          vm.users.splice(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML )),1);
        });
      }else{
        emails.forEach(function(element) {
          if(vm.users.indexOf(vm.filteredUsers.find( user => user.email === element.innerHTML ))==-1){
            vm.users.push(vm.filteredUsers.find( user => user.email === element.innerHTML ));
          }
        });
      }
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
    columnValueList(val) {
      return this.users_for_select.map(d => d[val])
    },
    async getMyOwnData(){
      var self=this;
      // var users=this.$localforage.df5c729d64ed93b36cbbbff41f179.map(d => self.decrypt_info(d))
      var myData=[]
      var myPanel=document.getElementById("myMainPannel")
      this.isFinallyLoaded = false;
      await this.$localforage.df5c729d64ed93b36cbbbff41f179.keys().then(async function(ans){
                                                                            await new Promise(function(resolve, reject) {                                                                             
                                                                              ans.map(async function(key){
                                                                                let code=await self.$localforage.df5c729d64ed93b36cbbbff41f179.getItem(key);
                                                                                myData.push(self.decrypt_info(code))                                                                            
                                                                                if(ans.length==myData.length){
                                                                                  resolve()
                                                                                }
                                                                              })                                                                              
                                                                            })                                                                            
                                                                          })                                                               
      this.users_for_select=myData;
      this.isFinallyLoaded = true;
    }
  },

}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/CounterUsersOffline.vue